import client from "../axios";
import { DefaultService } from "./DefaultService";
import { HttpStatusCode } from "../HttpStatusCode";

export default class RatingService extends DefaultService {
  static setRating(data: { [index: string]: any }): Promise<any> {
    return new Promise((resolve, reject) => {
      return client
        .post('/attendance-rating', data)
        .then((response) => {
          if (response.status === HttpStatusCode.CREATED || response.status === HttpStatusCode.OK) {
            if (response.data && response.data.success === false) {
              reject(response.data.join("\n"));
            } else {
              resolve(response);
            }
          } else reject(response.data.join("\n"));
        })
        .catch((error) => reject(error));
    });
  }
}
